import { red } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: "#8189ff"
    },
    secondary: {
      main: "#D97EA8"
    },
    error: {
      main: red.A400
    }
  },
  components: {
    // Name of the component
    MuiStepIcon: {
      styleOverrides: {
        root: {
          "&.Mui-active": {
            color: "#ffccee"
          },
          "&.Mui-completed": {
            color: "#D97EA8"
          }
        },
        text: {
          fill: "black"
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          display: "flex",
          "flex-direction": "column",
          "justify-content": "space-between"
        }
      }
    }
  }
});

export default theme;
